import React from 'react';
import Link from 'next/link';
import styles from '../../styles/compare/OfferInfo.module.scss';
import Image from 'next/image';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faPercentage, faCoins, faGift, faGem, faSync, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import * as gtag from '../../cookie/lib/gtag';

const CreditCardInfo = (props) => {
    const { details, viewDetails, sort, applyParams, product} = props;
    const handleViewDetails = () => {
        viewDetails(details.id);
    }

    let providerCol =   <Col xs="12" md="4">
                            {details.showLogo ?
                            <Image src={details.providerLogo} 
                                    height={details.logoSize.height}
                                    width={details.logoSize.width}
                                    alt={details.provider}
                            /> 
                            : 
                            <p className="mb-0 font-weight-bold">{details.bank}</p> }

                            <p className={`${styles.productName} mb-0`} >{details.product}</p>
                        </Col>;

    let freeInterestIcon = details.category.includes('freeInterest') && 
                            <span className={styles.offerBenefit}>
                                <FontAwesomeIcon className={styles.offerBenefitIcon} icon={faPercentage} height="16" width="16" /> Rate cu 0% dobândă
                            </span>;
    let cashbackIcon = details.category.includes('cashback') && 
                            <span className={styles.offerBenefit}>
                                <FontAwesomeIcon className={styles.offerBenefitIcon} icon={faCoins} height="16" width="16" /> Cashback
                            </span>;
    let rewardsIcon = details.category.includes('rewards') && 
                            <span className={styles.offerBenefit}>
                                <FontAwesomeIcon className={styles.offerBenefitIcon} icon={faGift} height="16" width="16" /> Puncte bonus
                            </span>;
    let premiumIcon = details.category.includes('rewards') && 
                            <span className={styles.offerBenefit}>
                                <FontAwesomeIcon className={styles.offerBenefitIcon} icon={faGem} height="16" width="16" /> Card premium
                            </span>;
    let refinanceIcon = details.category.includes('balanceTransfer') && 
                            <span className={styles.offerBenefit}>
                                <FontAwesomeIcon className={styles.offerBenefitIcon} icon={faSync} height="16" width="16" /> Opțiune refinațare
                            </span>;
   
    let benefitsCol =   <Col xs="12" md="8" className="pt-1">
                            {cashbackIcon} {rewardsIcon} {freeInterestIcon} {premiumIcon} {refinanceIcon}
                        </Col>;

    let purchaseAprColumn = 
                        <Col xs="4" className="p-2 text-center">
                            <p className={`${styles.indicator} `}>
                                DAE <br/>Cumpărături
                            </p>
                            <p className={`${styles.indicatorVal} ${sort=='purchaseApr' ? styles.active : ''}  mb-0`} suppressHydrationWarning>
                                {Intl.NumberFormat('fr', {maximumFractionDigits: 2}).format(details.purchaseApr)} %
                            </p>
                        </Col>
                        ;
    let cashAprColumn = 
                        <Col xs="4" className="p-2 text-center">
                            <p className={`${styles.indicator} `}>
                                DAE <br/> Numerar 
                            </p>
                            <p className={`${styles.indicatorVal} ${sort=='cashApr' ? styles.active : ''}  mb-0`} suppressHydrationWarning>
                                {Intl.NumberFormat('fr', {maximumFractionDigits: 2}).format(details.cashApr)} %
                            </p>
                        </Col>
                        ;
    let feeColumn = 
                        <Col xs="4" className="p-2 text-center">
                            <p className={`${styles.indicator} `}>
                                Taxa anuala<br/>
                                administrare
                            </p>
                            <p className={`${styles.indicatorVal} ${sort=='annualFee' ? styles.active : ''}  mb-0`} suppressHydrationWarning>
                                {Intl.NumberFormat('fr', {maximumFractionDigits: 0}).format(details.annualFee)} {details.currency}
                            </p>
                        </Col>
                        ;

    let detailsCol = <Col xs="6" md="4" className="py-3 text-center">
                        <Button variant="link" aria-label="Detalii" onClick={handleViewDetails}>
                            <u>Detalii</u>
                            <FontAwesomeIcon className="ms-2" icon={faChevronRight} height="16" width="16" />
                        </Button>
                    </Col>;

    let relOpennerTag;
    if (details.hasOwnProperty('apply')) {
        relOpennerTag = details.apply.indexOf(` ${process.env.NEXT_PUBLIC_SITE_URL} `) > -1 ? '' : 'noopener';
    } else if (details.hasOwnProperty('webLink')){
        relOpennerTag = details.webLink.indexOf(` ${process.env.NEXT_PUBLIC_SITE_URL} `) > -1 ? '' : 'noopener';
    } {
        relOpennerTag = '';
    }

    const onApply = () => {
        if (window.location.hostname.indexOf('conso.ro')>1) {
            gtag.event('Apply', {
                provider: details.provider,
                product: product,
            });
        } else {
            gtag.event('Apply', {
                provider: details.provider,
                product: product,
            });
            console.log("beta");
        }
    }

    let applyCol = details.hasOwnProperty('apply') &&
                    <Col xs="6" md="4" className="d-flex justify-content-center align-items-center mt-2">
                        <Link
                            href={ details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? 
                                    `${details.apply}${applyParams.length>0 ? '?'+ applyParams : ''}`
                                    : 
                                    details.apply
                                }
                            className="btn btn-primary"
                            onClick={onApply}
                            rel={relOpennerTag}
                            target={details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? '_self' : '_blank'}>
                            Solicită ofertă
                                                            <FontAwesomeIcon className="ms-2" icon={faChevronRight} height="16" width="16" />

                        </Link>
                    </Col>;

    let webLinkCol = details.hasOwnProperty('webLink') &&
                    <Col xs="6" md="4" className="d-flex justify-content-center align-items-center mt-2">
                        <Link
                            href={details.webLink}
                            className="btn btn-link"
                            rel={relOpennerTag}
                            target="_blank">

                            <FontAwesomeIcon className="me-1 green" icon={faExternalLinkAlt} height="16" width="16" />Website bancă
                                                        
                        </Link>
                    </Col>;


    return (
        <div className={`${styles.root} mb-5 p-3`}>
            <Row className={`${styles.product} justify-content-between mb-0`} >
                {providerCol}
                {benefitsCol}
            </Row>
            <Row className={`${styles.product} mb-0 justify-content-center`}>  
                {purchaseAprColumn}
                {cashAprColumn}  
                {feeColumn} 
            </Row>
            <Row className={ `mb-0 justify-content-between align-items-center`} >  
                {detailsCol}
                {applyCol}
                {webLinkCol}
            </Row>
        </div>
    );
}

export default CreditCardInfo;